import { useState } from "react";
import { sendToTelegram } from "../API/botTG";

export default function useForm() {
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [modal, setModal] = useState({
    isOpen: false,
    title: "",
    message: "",
  });

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Введите ваше имя";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Введите email";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Некорректный email";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Введите сообщение";
    } else if (formData.message.length < 10) {
      newErrors.message = "Сообщение слишком короткое";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // true если ошибок нет
  };

  const handleChange = (e) => {;
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleClick = async (e) => {
    e.preventDefault();

    if (!validate()) return; // ❗ стоп если есть ошибки

    try {
      setLoading(true);
      await sendToTelegram(formData);
      setLoading(false);

      setModal({
        isOpen: true,
        title: "✅ Сообщение успешно отправлено!",
        message:
          "Мы свяжемся с вами по указанной почте. Пожалуйста, проверяйте ваш почтовый ящик.",
      });

      setFormData({ name: "", email: "", message: "" });
      setErrors({});
    } catch (err) {
      console.error(err);

      setModal({
        isOpen: true,
        title: "❌ Ошибка при отправке сообщения.",
        message:
          "Не удалось отправить данные. Пожалуйста, попробуйте позже или напишите мне в соцсети.",
      });
    }
  };

  const closeModal = () => setModal({ ...modal, isOpen: false });

  // ✅ ВАЖНО: возвращаем наружу то, что нужно использовать
  return {
    formData,
    handleChange,
    handleClick,
    modal,
    closeModal,
    loading,
    errors,
  };
}
